import { gql } from '@apollo/client'

export const KUSTOMER_ARTICLE_VERSION_PREVIEW = gql`
  query kustomerArticleVersionPreview($versionId: String!) {
    kustomerArticleVersionPreview(versionId: $versionId) {
      id
      htmlBody
      title
    }
  }
`
